import { Route, Routes, Navigate, BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLeads from "./pages/AdminLeads";
import AdminTelecallers from "./pages/AdminTelecallers";
import AdminReports from "./pages/AdminReports";
import AdminNotices from "./pages/AdminNotices";
import TelecallerDashboard from "./pages/TelecallerDashboard";
import TelecallerNotices from "./pages/TelecallerNotices";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/leads" element={<ProtectedRoute role="admin"><AdminLeads /></ProtectedRoute>} />
            <Route path="/admin/telecallers" element={<ProtectedRoute role="admin"><AdminTelecallers /></ProtectedRoute>} />
            <Route path="/admin/notices" element={<ProtectedRoute role="admin"><AdminNotices /></ProtectedRoute>} />
            <Route path="/admin/reports" element={<ProtectedRoute role="admin"><AdminReports /></ProtectedRoute>} />
            <Route path="/my-leads" element={<ProtectedRoute role="telecaller"><TelecallerDashboard /></ProtectedRoute>} />
            <Route path="/notices" element={<ProtectedRoute role="telecaller"><TelecallerNotices /></ProtectedRoute>} />
          </Route>

          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
